// src/graphql/queries/trendQueries.js
// Global market-signal queries computed from narrative profiles (taxonomy
// tags, domains, budgets). All are auth-only with no company scope, so they
// reflect the whole corpus — ideal for the admin dashboard.
// TimeRangeInput accepts { preset: "last_30_days" | ... } or explicit
// startDate/endDate ISO strings.

export const getTopTags = () => `query GetTopTags($timeRange: TimeRangeInput, $limit: Int) {
    topTags(timeRange: $timeRange, limit: $limit) {
        tag
        count
    }
}`;

export const getTopDomains = () => `query GetTopDomains($timeRange: TimeRangeInput, $limit: Int) {
    topDomains(timeRange: $timeRange, limit: $limit) {
        tag
        count
    }
}`;

export const getNarrativeStats = () => `query GetNarrativeStats($timeRange: TimeRangeInput) {
    narrativeStats(timeRange: $timeRange) {
        totalNarratives
        frameworkRate
        localPresenceRate
        avgBudgetEUR
        medianBudgetEUR
        avgDurationMonths
        range {
            start
            end
        }
    }
}`;

export const getBudgetByDomain = () => `query GetBudgetByDomain($timeRange: TimeRangeInput, $limit: Int) {
    budgetByDomain(timeRange: $timeRange, limit: $limit) {
        domain
        count
        avgBudgetEUR
        medianBudgetEUR
    }
}`;
